function FileSharing(core) {
    this.client = core.client;
    this._fileStorageServer = 'https://fs.wildix.com/api/v1/File/';
    this._fileStorageToken = 'https://auth.wildix.com/api/v2/Token/FileStorage/';
}

Object.assign(FileSharing.prototype, {
    namespace: 'FileSharing',
    createFile(data, headers = {}) {
        return this.client.sendFormData('POST', this._fileStorageServer, data, headers);
    },
    getAuthTokenForFileStorage(headers) {
        return this.client.send('GET', this._fileStorageToken, {}, headers);
    },
    getOneTimePassword(url, params) {
        return this.client.send('GET', url, params);
    },
    getStatus(urlPart, headers = {}) {
        return this.client.send('GET', this._fileStorageServer + urlPart, {}, headers);
    },
    uploadFile(url, data, progressCallback) {
        return this.client.sendFormData('POST', url, data, {}, progressCallback);
    },
    cancelUpload() {
        this.client.cancel();
    }
});

export default FileSharing;
